import Vue from 'vue'
import store from '@/store/root.store'
import router from '@/router'
import i18n from '@/commons/translations/i18n'
import 'bootstrap'

import App from '@/App.vue'
import '@/commons/configuration/vee.validate'
import { ErrorUtils } from '@/commons/utils/error'
import '@/commons/configuration/generate.font.awesome'

Vue.config.productionTip = false
router.onError(ErrorUtils.routerErrorHandler)
Vue.config.errorHandler = ErrorUtils.globalErrorHandler

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
